<template>
  <div class="pa-6" style="background-color: #F4F7FE; min-height: 100vh;">
    <v-row align="center" class="mb-8">
      <v-col>
        <h1 class="text-h4 font-weight-black" style="color: #1B2559;">Gestión de Usuarios</h1>
        <p class="grey--text">Control de acceso y perfiles del personal</p>
      </v-col>
      <v-col class="text-right" v-if="rol == '1'">
        <v-btn color="#4318FF" dark large class="rounded-lg font-weight-bold" @click="$router.push({ name: 'NuevoUsuario' })">
          <v-icon left>mdi-account-plus</v-icon> NUEVO USUARIO
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="rounded-xl border shadow-sm" elevation="0">
      <v-data-table :headers="headers" :items="usuarios" class="elevation-0">
        <template v-slot:item.foto="{ item }">
          <v-avatar size="40" class="my-2 list-avatar elevation-1">
            <v-img :src="urlImagen(item.foto)" />
          </v-avatar>
        </template>

        <template v-slot:item.rol="{ item }">
          <v-chip :color="item.rol == '1' ? '#4318FF' : '#FFB547'" dark small class="font-weight-bold">
            {{ item.rol == '1' ? 'ADMIN' : 'VENDEDOR' }}
          </v-chip>
        </template>

        <template v-slot:item.acciones="{ item }">
          <div v-if="rol == '1'">
            <v-btn icon class="action-edit" @click="$router.push({ name: 'EditarUsuario', params: { id: item.id } })">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn icon class="action-danger" @click="eliminar(item.id)">
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </div>
          <span v-else class="text-caption grey--text">Solo lectura</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
export default {
  data: () => ({
    usuarios: [],
    rol: localStorage.getItem("rol"),
    headers: [
      { text: 'Perfil', value: 'foto', sortable: false },
      { text: 'DNI', value: 'dni' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Rol', value: 'rol' },
      { text: 'Usuario', value: 'usuario' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Acciones', value: 'acciones', align: 'end', sortable: false }
    ]
  }),
  methods: {
    urlImagen(imagen) {
      return Utiles.generarURL(imagen, 'usuarios');
    },
    async obtenerUsuarios() {
      const res = await HttpService.obtenerConDatos({ metodo: "get" }, "usuarios.php");
      this.usuarios = res;
    },
    async eliminar(id) {
      if(this.rol !== '1') return;
      if(!confirm("¿Eliminar usuario?")) return;
      let p = { 
        metodo: "delete", 
        id: id, 
        idSolicitante: localStorage.getItem("idUsuario") 
      };
      await HttpService.registrar(p, "usuarios.php");
      this.obtenerUsuarios();
    }
  },
  mounted() { this.obtenerUsuarios(); }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/Usuarios.vue